import { notification } from 'antd';
import apiClient from 'services/axios'
import ApiConfig from 'services/config';

const {PartnerConfig} = ApiConfig;

export async function showPartners(businessCode) {
  return apiClient
    .get(PartnerConfig.Partner.concat(businessCode))
    .then(response => {
      if (response) {
        return response.data
      }
      return false
    })
    .catch(err => console.log(err))
}

export async function showPartnerGoogleBusinessAccounts(businessCode) {
  return apiClient
    .get(PartnerConfig.PartnerGoogleBusinessAccounts.concat(businessCode))
    .then(response => {
      if (response) {
        return response.data
      }
      return false
    })
    .catch(err => console.log(err))
}

export async function connectPartner(businessCode, deviceName) {
  let url = "";
  if(deviceName === 'clover'){
    url = PartnerConfig.PartnerCloverConnect
  }
  return apiClient
    .get(url.concat(businessCode))
    .then(response => {
      if (response) {
        return response.data
      }
      return false
    })
    .catch(err => console.log(err))
}

export async function disconnectPartner(businessCode, deviceName) {
  let url = "";
  if(deviceName === 'clover'){
    url = PartnerConfig.PartnerCloverDisconnect
  }
  return apiClient
    .delete(url.concat(businessCode))
    .then(response => {
      if (response) {
        return response.data
      }
      return false
    })
    .catch(err => {
      notification.error({
        message : err.data.message || 'Oops, something went wrong!'
      })
    })
}
